// плавный скролл страницы
$(document).ready(function () {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  );
  else {
    const body = document.body,
      scrollWrap = document.querySelector("#my-scrollbar"),
      speed = 0.1;

    body.classList.add("no-scroll");
    scrollWrap.classList.add("scroll-container");

    let height = scrollWrap.getBoundingClientRect().height - 1,
      offset = 0;

    body.style.height = Math.floor(height) + "px";

    function smoothScroll() {
      if (height != scrollWrap.getBoundingClientRect().height - 1) {
        height = scrollWrap.getBoundingClientRect().height - 1;
        body.style.height = Math.floor(height) + "px";
      }

      const scrollCss =
        "translateY(-" +
        (offset += speed * (window.pageYOffset - offset)) +
        "px) translateZ(0)";
      scrollWrap.style.transform = scrollCss;
      requestAnimationFrame(smoothScroll);
      // callScroll = requestAnimationFrame(smoothScroll);
    }
    requestAnimationFrame(smoothScroll);
  }
});
